import { render, staticRenderFns } from "./YljInviteRecord.vue?vue&type=template&id=126e6582&scoped=true&"
import script from "./YljInviteRecord.vue?vue&type=script&lang=js&"
export * from "./YljInviteRecord.vue?vue&type=script&lang=js&"
import style0 from "./YljInviteRecord.vue?vue&type=style&index=0&id=126e6582&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126e6582",
  null
  
)

export default component.exports